const zoom = 15;
let map = null;
let ps = null;

function selectAddress() {
    const coords = $(this).data("coords");

    $(this).siblings().removeClass("active").end().addClass("active");
    map.setCenter(coords, zoom);
}

function addPlacemarks() {
    $(".contacts__item").each(function () {
        const address = $(this).find(".contacts__address").text();
        const coords = $(this).data("coords");

        const placemark = new ymaps.Placemark(
            coords,
            {
                hintContent: address,
                balloonContent: address,
                iconContent: "",
            },
            {
                // Опции.
                // Необходимо указать данный тип макета.
                iconLayout: "default#image",
                // Своё изображение иконки метки.
                iconImageHref: "/img/default/contacts/marker.svg",
                // Размеры метки.
                iconImageSize: [40, 50],
                // Смещение левого верхнего угла иконки относительно
                // её "ножки" (точки привязки).
                iconImageOffset: [-20, -50],
            }
        );

        map.geoObjects.add(placemark);
    });
}

$(function () {
    if ($("#contacts__list").length === 0) return;

    if ($(window).width() >= 980) {
        ps = new PerfectScrollbar("#contacts__list");
    }

    ymaps.ready(init);

    $(document).on("click", ".contacts__item", selectAddress);
});

function init() {
    const $active = $(".contacts__item.active");

    map = new ymaps.Map(
        "map",
        {
            center: $active.data("coords"),
            zoom,
        },
        {
            searchControlProvider: "yandex#search",
        }
    );

    map.behaviors.disable("scrollZoom");

    addPlacemarks();
}
